module.exports = __webpack_public_path__ + "img/empty-forms-dark.129c9a14.svg";